(function () {
  'use strict';
  if (customElements.get('quantity-counter')) return;

  customElements.define(
    'quantity-counter',
    class extends HTMLElement {
      connectedCallback() {
        if (this.__mayBound) return;
        this.__mayBound = true;
        this.input = this.querySelector('input');
        if (!this.input) return;
        this.changeEvent = new Event('change', { bubbles: true });
        this._onButtonClick = this.onButtonClick.bind(this);
        this._onQuantityChange = this.onQuantityChange.bind(this);
        this.input.addEventListener('change', this._onQuantityChange);
        this.querySelectorAll('button').forEach(
          function (btn) {
            btn.addEventListener('click', this._onButtonClick);
          }.bind(this)
        );
      }

      disconnectedCallback() {
        if (!this.__mayBound) return;
        this.__mayBound = false;
        if (this.input && this._onQuantityChange) {
          this.input.removeEventListener('change', this._onQuantityChange);
        }
        if (this._onButtonClick) {
          this.querySelectorAll('button').forEach(
            function (btn) {
              btn.removeEventListener('click', this._onButtonClick);
            }.bind(this)
          );
        }
      }

      onButtonClick(event) {
        // mayceline-cart-fast captures clicks first; if already handled, bail
        if (event.defaultPrevented) return;
        event.preventDefault();
        var prev = this.input.value;
        var button =
          event.target.nodeName === 'BUTTON' ? event.target : event.target.closest('button');
        if (!button) return;
        if (button.name === 'increase') this.input.stepUp();
        if (button.name === 'decrease') this.input.stepDown();
        if (prev !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }

      onQuantityChange() {
        if (this.input && this.input.dataset && this.input.dataset.id) this.updateCart();
      }

      updateCart() {
        if (!this.input || this.input.value === '') return;
        this.dispatchEvent(
          new CustomEvent('theme:cart:update', {
            bubbles: true,
            cancelable: true,
            detail: { id: this.input.dataset.id, quantity: this.input.value },
          })
        );
      }
    }
  );
})();
